import { darken, lighten } from 'polished';
import styled from 'styled-components';

interface IContainer {
  returnTopActive: boolean;
}

export const Container = styled.div<IContainer>``;

export const Hero = styled.div`
  min-height: 100vh;
  border-radius: 0px 0px 50px 50px;
  overflow: hidden;

  video {
    object-fit: cover;
  }

  .blue-detail {
    left: 0;
    top: 0;
  }

  .white-detail {
    left: 0;
    bottom: 0;
  }

  h1 {
    span {
      color: #0075ff;
      background: linear-gradient(135deg, #0075ff 38.95%, #6cd7e5 110%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .highlight {
    border-radius: 81px;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(19.799999237060547px);
    display: flex;
    align-items: center;
    padding: 6.69px;

    div {
      border-radius: 81px;
      background: rgba(255, 255, 255, 0.65);
      backdrop-filter: blur(19.799999237060547px);
      width: 100%;
      height: 57.87px;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        color: #727272;
      }
    }
  }

  .scroll {
    transition-duration: 0.3s;
    bottom: 50px;
    color: #858585;

    > span {
      border: 1px solid #0075ff;
      color: #0075ff;
      border-radius: 20px;
      height: 36px;
      width: 23px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      transition-duration: 0.3s;
    }
  }

  .col {
    > div {
      width: 100%;
      overflow: hidden;
      border-radius: 8px;

      > div {
        top: 0;

        > p {
          font-size: 10px;
          line-height: 15px;
          color: #ffffff;
        }

        > div {
          background: rgba(32, 32, 32, 0.4);
          backdrop-filter: blur(2px);
          border-radius: 8px;

          > div {
            width: 14.38px;
            height: 14.38px;
            background: rgba(255, 255, 255, 0.4);
          }

          > p {
            color: #ffffff;
            line-height: 9px;
            font-size: 6px;
            width: calc(100% - 19px);
          }
        }
      }
    }

    .btn-idea {
      background-color: #0075ff;
      font-weight: 500;
      line-height: 24px;
      color: #ffffff;

      span {
        background: #ffffff;
        box-shadow: -17px 19px 32px rgba(7, 7, 7, 0.1);
        border-radius: 18px;
        width: 25px;
        height: 25px;
      }
    }
  }

  .btn-budget {
    font-weight: 500;
    border-radius: 12px;
    background: #1c1c1c;
    color: #ffffff;

    :hover {
      background: ${lighten(0.1, '#1c1c1c')};
    }
  }

  .break-show {
    display: none;
  }

  @media screen and (min-width: 428px) and (max-width: 575px) {
    .normal-small {
      font-size: 100%;
    }

    .break-show {
      display: block;
    }
  }

  @media screen and (min-width: 992px) {
    .col {
      > div {
        border-radius: 20px;

        > div {
          > p {
            font-size: 24px;
            line-height: 36px;
          }

          > div {
            border-radius: 20px;

            > div {
              width: 39px;
              height: 39px;
            }

            > p {
              line-height: 21px;
              font-size: 14px;
              width: calc(100% - 50px);
            }
          }
        }
      }
      .btn-idea {
        span {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
`;

export const Highlight = styled.div`
  h2 {
    color: #84889a;
  }

  .dark-box {
    border-radius: 20px;
    background-color: #121316;
    overflow: hidden;
    height: 790px;
    padding: 37px 12px;

    .text-gray {
      color: #c4c4c4;
    }

    img {
      left: 0;
      bottom: -170px;
    }
  }

  .bg-gray {
    width: 100%;
    height: 267px;
    border-radius: 16px;
    background-color: #f6f6f6;

    p.h4 {
      color: #202020;
    }

    p.small {
      color: #707070;
    }

    svg {
      width: 36px;
      height: 36px;
    }
  }

  @media screen and (min-width: 428px) and (max-width: 575px) {
    .dark-box {
      height: 790px;
      padding: 37px 37px;

      img {
        width: 100%;
      }
    }

    .padding-small {
      padding: 2rem !important;

      p.h5 {
        font-size: 1.5rem !important;
      }

      p.small {
        font-size: 100% !important;
      }
    }

    @media screen and (min-width: 460px) {
      .dark-box {
        img {
          height: 620px;
          bottom: -200px;
        }
      }
    }

    @media screen and (min-width: 500px) {
      .dark-box {
        img {
          height: 700px;
        }
      }
    }
  }

  @media screen and (min-width: 576px) {
    .dark-box {
      height: 540px;
      padding: 106px 60px;

      img {
        object-fit: cover;
        width: 175px;
        height: 100%;
        right: 0;
        top: 0;
        left: unset;
        bottom: unset;
      }
    }
  }

  @media screen and (min-width: 768px) {
    .dark-box {
      height: 540px;
      padding: 100px 45px;

      img {
        width: 225px;
      }
    }
  }

  @media screen and (min-width: 992px) {
    .dark-box {
      padding: 106px 60px;

      img {
        right: 0;
        top: 0;
        left: unset;
        bottom: unset;
        object-fit: unset;
        width: unset;
        height: unset;
      }
    }

    .bg-gray {
      height: 385px;

      svg {
        width: 57px;
        height: 57px;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .dark-box {
      padding: 106px 101px;
    }

    .bg-gray {
      height: 406px;
    }
  }
`;

export const AboutUs = styled.div`
  h2 {
    color: #84889a;
  }

  .rectangle {
    border-radius: 18px;
    height: 114.43px;
  }

  .logo {
    width: 108.28px;
    right: 25px;
    bottom: 12px;
  }

  .code-design {
    bottom: -9.25px;
    left: 17.81px;

    .bg-dark-gray {
      width: 27.41px;
      height: 27.41px;
      background-color: #353c41;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  p.fs-4 {
    color: #707070;
  }

  @media screen and (min-width: 575px) {
    .logo {
      width: 150px;
      right: 25px;
      bottom: 12px;
    }

    .code-design {
      bottom: -16px;
      left: 30px;

      .bg-dark-gray {
        width: 50px;
        height: 50px;

        svg {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    .rectangle {
      border-radius: 27px;
      height: 201.64px;
    }

    .logo {
      width: auto;
      right: 57px;
      bottom: 38px;
    }

    .code-design {
      bottom: -16px;
      left: 30px;

      .bg-dark-gray {
        width: 71.88px;
        height: 71.88px;

        svg {
          width: 44px;
          height: 44px;
        }
      }
    }
  }
`;

export const Portfolio = styled.div`
  h2 {
    color: #84889a;
  }

  .highlight {
    background-color: #f9f9f9;
    border-radius: 24px;
    border: 1px solid rgba(40, 40, 40, 0.08);
    overflow: hidden;

    p {
      color: #121316;
    }

    :hover {
      p {
        color: #121316;
      }
    }

    img {
      width: 100%;
    }
  }

  .rolling-wrapper {
    overflow: hidden;
    width: 100%;
    background-color: #fff; /* opcional */
  }

  .rolling-track {
    display: flex;
    width: max-content;
    animation: scroll-left 30s linear infinite;
  }

  .rolling-track a {
    flex: 0 0 auto;
    padding: 0 2rem; /* espaçamento opcional entre os logos */
    filter: brightness(0);
    transition: filter 0.3s ease-in-out;

    :hover {
      filter: brightness(1);
    }
  }

  .rolling-track img {
    height: 41px; /* ajuste conforme necessário */
    object-fit: contain;
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-2059px);
    }
  }
`;

export const Testimonials = styled.div`
  h2 {
    color: #84889a;
  }

  .box {
    background: #fff;
    border: 1px solid #ebebeb;
    border-radius: 16px;
    padding: 36px 22px;
    height: 100%;

    > div {
      .avatar {
        width: 42.36px;
        height: 42.36px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #d9d9d9;
      }

      p {
        color: #202020;
      }
    }

    > p {
      color: #707070;
    }
  }
`;

export const OurServices = styled.div`
  .blue-box {
    background: linear-gradient(102.85deg, #f4f9ff 3.14%, #fafafa 100.62%);
    border-radius: 34px;

    p.h2-xl {
      color: #121316;
    }

    p.fs-xl-2 {
      color: #828282;
    }
  }

  .box {
    border-radius: 30px;
    background: #ffffff;
    box-shadow: 0px 4px 39px 0px #7979791f;
    height: 428px;
    top: -88px;

    .starts {
      top: -90px;
      right: 50%;
      transform: translateX(50%);
      width: 267px;
    }
  }

  .break-show {
    display: none;
  }

  @media screen and (min-width: 547px) and (max-width: 575px) {
    .break-show {
      display: block;
    }
  }

  @media screen and (min-width: 992px) {
    .box {
      overflow: hidden;

      .starts {
        width: 60%;
        top: -10%;
        right: -50px;
        transform: unset;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .box {
      .starts {
        top: -20%;
        right: -80px;
      }
    }
  }

  @media screen and (min-width: 1400px) {
    .box {
      .starts {
        top: -30%;
      }
    }
  }
`;

export const Faq = styled.div`
  h2 {
    color: #202020;
  }

  a {
    border: 1px solid #dbe1eb;
    width: 100%;

    span:nth-child(1) {
      width: 24px;
      height: 24px;
      background: #0be094;
      border-radius: 50%;
      margin-right: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span:nth-child(2) {
      color: #637e9e;
      font-size: 12px;

      b {
        font-size: 16px;
        color: #304762;
      }
    }
  }

  .question {
    background: #f9f9f9;
    border-radius: 20px;

    .btn-faq {
      background: #f9f9f9;
      border-radius: 20px;
      height: 77px;
      color: #707070;
      font-size: 16px;
      transition-duration: 0.3s;

      svg {
        transition-duration: 0.3s;
        transform: rotateZ(90deg);
      }

      span {
        width: calc(100% - 25px);
      }
    }

    .btn-faq.opened,
    .btn-faq:hover {
      background: ${darken(0.02, '#f9f9f9')};
    }

    .btn-faq.opened {
      svg {
        transform: rotateZ(180deg);
      }
    }

    .answer {
      transition-duration: 0.3s;
      height: 0;
      overflow: hidden;

      p {
        color: #204c81;
      }
    }

    :nth-child(1) {
      .answer.opened {
        height: 160px;
      }
    }

    :nth-child(2) {
      .answer.opened {
        height: 224px;
      }
    }

    :nth-child(3) {
      .answer.opened {
        height: 304px;
      }
    }

    :nth-child(4) {
      .answer.opened {
        height: 176px;
      }
    }
  }

  @media screen and (min-width: 992px) {
    a {
      width: 352px;

      span:nth-child(1) {
        width: 36px;
        height: 36px;
        margin-right: 13px;
      }

      span:nth-child(2) {
        font-size: 16px;
      }
    }

    .question {
      .btn-faq {
        font-size: 20px;
      }

      :nth-child(1) {
        .answer.opened {
          height: 112px;
        }
      }

      :nth-child(2) {
        .answer.opened {
          height: 152px;
        }
      }

      :nth-child(3) {
        .answer.opened {
          height: 160px;
        }
      }

      :nth-child(4) {
        .answer.opened {
          height: 128px;
        }
      }
    }
  }
`;
